// extracted by mini-css-extract-plugin
module.exports = {"strip":"DealCountdown_strip__r35_2","label":"DealCountdown_label__LuUS6","dot":"DealCountdown_dot__n2KQO","dealDot":"DealCountdown_dealDot__QmbsG"};